import Control from './Control';
import Preview from './Preview';

export default {
  Control,
  Preview,
};
